module.exports = __webpack_public_path__ + "static/img/fish33.f4bd6a2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/fugufish/fish33.png
// module id = IlGV
// module chunks = 0